import React, { useContext } from "react";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";

import axios from "axios";
import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Global from "../util/Global";
import { LoaderComponent } from "../util/Loader";
import DirectoryFilter, { DirectoryOrder } from "../components/directories/DirectoryComponents";
import Pagination from "../components/Pagination";
import NotFound from "../components/NotFound";
import { DeliveryCountryContext } from "../components/Utils";



const Annuaires = () => {

  const urlActivity = new URLSearchParams(useLocation().search).get('activity')

  const { t } = useTranslation()
  const [companyList, setcompanyList] = useState([]);
  const [isLoading, setisLoading] = useState(true)
  const {countries}=useContext(DeliveryCountryContext)
  const [filteredItems, setfilteredItems] = useState([])
  const [paginatedItems, setpaginatedItems] = useState([])
  const [orderedItems, setorderedItems] = useState([])

  const ANNUAIRE_URL = Global.backend + "/index.php/entreprise/list";
  const USERS_URL = Global.backend + "/index.php/user/showallUsers";


  useEffect(() => {
    setisLoading(true)

    axios.all([
      //axios.get(ANNUAIRE_URL),
      axios.post(USERS_URL, { userId: localStorage.getItem("id"), businessOnly: true })
    ]).then(axios.spread(( usersResponse) => {



      setcompanyList(usersResponse.data.map(user => user.entreprise))
    })).finally(() => {
      setisLoading(false)
    })
  }, []);



  return (
    <div>
      <LoaderComponent isLoading={isLoading}>
        <main
          className="my-main ttm-bgcolor-grey"
          style={{
            minHeight: "calc(100vh + 700px)",
          }}
        >
          <div className="container-fluid bg-trasparent my-4 p-3">
            <div className="row">
              <DirectoryFilter title={t("navigation5.1")} companyList={companyList} setFilteredList={setfilteredItems} pays={countries} urlActivity={urlActivity} />

              <div className="col-md-9">
                <div className="container-fluid">
                  <div className="row">
                    <DirectoryOrder items={filteredItems} setOrderedItems={setorderedItems} />
                    {paginatedItems.map((annuaire, index) => (
                      <div key={index} className="col-md-4">
                        <NavLink to={`/entreprise/${annuaire.nom}`}>
                          <div className="styles_ProCard__Tjh5g ttm-bgcolor-white p-30 border-rad_5" style={{ marginTop: 30, backgroundColor: "#FFF" }}>

                            <div className="styles_logo__4qFlH">
                                    <img src={`${Global.backend}/uploads/${annuaire.logo}`} className="_1cnjm" />
                            </div>


                            <div >
                              <h6>{annuaire.nom}</h6>


                              <div>
                                <i class="fa fa-flag" aria-hidden="true"></i>
                                <span> {annuaire.pays}</span>
                              </div>

                              <div>
                                <i className="fa fa-map-marker fa-1x" aria-hidden="true"></i>
                                <span> {annuaire.ville + " - " + annuaire.adresse + " " + annuaire.code_postal}</span>
                              </div>

                              <div>
                                <i class="fa fa-briefcase" aria-hidden="true"></i>
                                <span> {t("user.activities." + annuaire.activite)}</span>
                              </div>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                    ))}
                    {!paginatedItems.length && <NotFound />}
                  </div>
                  <Pagination itemsPerPage={10} items={orderedItems} setItems={setpaginatedItems} />
                </div>
              </div>
            </div>
          </div>


        </main>
      </LoaderComponent>
      <Footer />
    </div>
  )

};

export default Annuaires;
